import { SimpleChange } from '@angular/core';

import get from 'lodash-es/get';
import isEqual from 'lodash-es/isEqual';

export function hasInputChangedSinceInit(
  changedProperty: SimpleChange,
): boolean {
  return (
    changedProperty &&
    !isEqual(changedProperty.previousValue, changedProperty.currentValue) &&
    !changedProperty.isFirstChange()
  );
}

export function hasInputPropertyChanged(
  changedProperty: SimpleChange,
  path: string,
): boolean {
  return (
    changedProperty &&
    !isEqual(
      get(changedProperty.previousValue, path),
      get(changedProperty.currentValue, path),
    )
  );
}
